import React, { useState } from 'react'

import { ConfirmedOrder } from '../orders-detail/orders-types'
import { OrderConfirmed } from './order-confirmed'
import { OrderCorrectPriceModal } from './order-correct-price-modal'
import { OrderCorrected, OrderCorrectPrice } from './order-corrected'
import classes from './order-economics.module.scss'

interface OrdersOrderEconomicsProps {
  order: ConfirmedOrder
}

export const OrderEconomics = ({ order }: OrdersOrderEconomicsProps) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <OrderCorrectPriceModal
        isOpen={showModal}
        order={order}
        onClose={() => setShowModal(false)}
      />
      <div className={classes.historyWrapper}>
        <div className={classes.timelineTrack} />
        <ul className={classes.cardList}>
          {order.correction ? (
            <li className={classes.correctPrice}>
              <OrderCorrected order={order} />
            </li>
          ) : (
            <li>
              <OrderCorrectPrice showModal={() => setShowModal(true)} />
            </li>
          )}
          <li>
            <OrderConfirmed order={order} />
          </li>
        </ul>
      </div>
    </>
  )
}
